import * as React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Modal, Input, Row, Col } from 'antd'

export default class RoleOperationModal extends ComponentExt<
  {
    showRoleOperation?: boolean
    toggleRoleOperation?: () => void
    activeLesson: any
    getCheckRoles(): Promise<any>
  },
  any
> {
  state = {
    visible: false,
    name: '',
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (nextProps.showRoleOperation !== prevState.visible) {
      return {
        ...prevState,
        visible: nextProps.showRoleOperation,
      }
    }

    return prevState
  }

  handleOk = async (): Promise<any> => {
    const payload = {
      name: this.state.name.trim(),
      lesson_id: this.props.activeLesson.id,
    }
    if (!payload.name) {
      return this.$message.info('请输入角色名称。')
    }

    await this.api.level.addCheckRole(payload)

    this.toggleVisible()
    this.props.getCheckRoles()
    this.setState({ name: '' })
  }

  toggleVisible = () => {
    if (this.props.toggleRoleOperation) {
      this.props.toggleRoleOperation()
    }
  }

  onCancel = () => {
    this.setState({ name: '' })
    this.toggleVisible()
  }

  render() {
    const { visible, name } = this.state
    const { activeLesson } = this.props
    return (
      <Modal
        title={`新增角色（${activeLesson.name}）`}
        visible={visible}
        onOk={this.handleOk}
        onCancel={this.onCancel}
      >
        <Row type="flex" align="middle">
          <Col span={5}>
            <label htmlFor="role">
              <span style={{ color: 'red' }}>*</span> 角色名称：
            </label>
          </Col>
          <Col span={19}>
            <Input
              id="role"
              onChange={e => this.setState({ name: e.target.value })}
              placeholder="请输入角色名称"
              value={name}
            />
          </Col>
        </Row>
      </Modal>
    )
  }
}
